import { requiredString } from "common";
import { CheckInValidationType } from "types";
import { array, boolean, number, object } from "yup";

export const validationSchema = {
    enabled: boolean().required(),
    multiCheckInEnabled: boolean(),
    validations: array().of(
        object().shape({
            object: requiredString(),
            max: number().test("valid", "limit can't be less than 2", (value, context) => {
                const isMultiCheckInEnabled = !!(context as any).from[1].value.multiCheckInEnabled;

                if (context.parent.object === CheckInValidationType.COUNT && isMultiCheckInEnabled) {
                    return !!value && value >= 2;
                }

                return true;
            }),
        }),
    ),
};
